// Adds prev/next arrows under every swipe row (.ls-strip), so it also works with a mouse.
// The arrows hide themselves when the row fits on screen (desktop grids).
(function () {
  var arrow = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';

  function setup(strip) {
    if (strip.dataset.lsArrows) return;
    strip.dataset.lsArrows = '1';
    var nav = document.createElement('div');
    nav.className = 'ls-strip-nav';
    nav.innerHTML =
      '<button type="button" class="ls-strip-nav__btn" data-dir="-1" aria-label="Previous">' + arrow + '</button>' +
      '<button type="button" class="ls-strip-nav__btn ls-strip-nav__btn--next" data-dir="1" aria-label="Next">' + arrow + '</button>';
    strip.after(nav);
    var prev = nav.children[0], next = nav.children[1];

    function step() {
      var item = strip.firstElementChild;
      if (!item) return strip.clientWidth;
      var gap = parseFloat(getComputedStyle(strip).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = strip.scrollWidth - strip.clientWidth;
      nav.hidden = max < 4;
      prev.disabled = strip.scrollLeft < 4;
      next.disabled = strip.scrollLeft > max - 4;
    }
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (btn) strip.scrollBy({ left: step() * +btn.dataset.dir, behavior: 'smooth' });
    });
    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    // data-autoplay="ms": move on one card at a time while the row is on screen; any touch pauses it for a while.
    var every = +strip.dataset.autoplay;
    if (!every || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var pausedUntil = 0, visible = false;
    function pause() { pausedUntil = Date.now() + 10000; }
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) { strip.addEventListener(ev, pause, { passive: true }); });
    nav.addEventListener('click', pause);
    new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { threshold: 0.5 }).observe(strip);
    setInterval(function () {
      if (!visible || nav.hidden || document.hidden || Date.now() < pausedUntil) return;
      var max = strip.scrollWidth - strip.clientWidth;
      if (strip.scrollLeft > max - 4) strip.scrollTo({ left: 0, behavior: 'smooth' });
      else strip.scrollBy({ left: step(), behavior: 'smooth' });
    }, every);
  }

  function init() { document.querySelectorAll('.ls-strip').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
